import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-inspect`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 添加巡检点类型
  addInspectDeviceType: `${baseUrl}/inspectDeviceCategory/add`,

  // 修改巡检点类型
  updateInspectDeviceType: `${baseUrl}/inspectDeviceCategory/update`,

  // 删除巡检点类型
  deleteInspectDeviceType: `${baseUrl}/inspectDeviceCategory/deleteByCodes`,

  // 获取巡检点类型列表
  getInspectDeviceTypeList: `${baseUrl}/inspectDeviceCategory/getList`,

  // 获取巡检点类型分页
  getInspectDeviceTypePage: `${baseUrl}/inspectDeviceCategory/getPage`,

  // 获取巡检点分页
  getInspectDevicePage: `${baseUrl}/inspectPoint/getPage`,

  // 添加巡检点
  addInspectDevice: `${baseUrl}/inspectPoint/add`,

  // 巡检点详情
  getInspectDeviceByCode: `${baseUrl}/inspectPoint/getByCode`,

  // 修改巡检点
  updateInspectDevice: `${baseUrl}/inspectPoint/update`,

  // 删除巡检点
  deleteInspectDevice: `${baseUrl}/inspectPoint/deleteByCodes`,

  // 导出巡检点
  exportInspectDevice: `${baseUrl}/inspectPoint/export`,

  // 导入巡检点
  importInspectDevice: `${baseUrl}/inspectPoint/import`,

  // 巡检人员分页
  getInspectPersonPage: `${baseUrl}/inspectPerson/getPage`,

  // 巡检人员添加
  addInspectPerson: `${baseUrl}/inspectPerson/add`,

  // 巡检人员详情
  getInspectPersonByCode: `${baseUrl}/inspectPerson/getByCode`,

  // 巡检人员修改
  updateInspectPerson: `${baseUrl}/inspectPerson/update`,

  // 巡检人员删除
  deleteInspectPersonByCodes: `${baseUrl}/inspectPerson/deleteByCodes`,

  // 巡检人员列表
  getExecutePersonList: `${baseUrl}/inspectPerson/getExecutePersonList`,

  // 巡检班组分页
  getInspectTeamPage: `${baseUrl}/inspectTeam/getPage`,

  // 巡检班组添加
  addInspectTeam: `${baseUrl}/inspectTeam/add`,

  // 巡检班组详情
  getInspectTeamByCode: `${baseUrl}/inspectTeam/getByCode`,

  // 巡检班组修改
  updateInspectTeam: `${baseUrl}/inspectTeam/update`,

  // 巡检班组删除
  deleteInspectTeamByCodes: `${baseUrl}/inspectTeam/deleteByCodes`,

  // 巡检班组列表
  getInspectTeamList: `${baseUrl}/inspectTeam/getList`,

  // 巡检计划分页
  getInspectPlanPage: `${baseUrl}/inspectPlan/getPage`,

  // 巡检计划详情
  getInspectPlanByCode: `${baseUrl}/inspectPlan/getByCode`,

  // 巡检计划添加
  addInspectPlan: `${baseUrl}/inspectPlan/add`,

  // 巡检计划修改
  updateInspectPlan: `${baseUrl}/inspectPlan/update`,

  // 巡检计划删除
  deleteInspectPlanByCodes: `${baseUrl}/inspectPlan/deleteByCodes`,

  // 获取巡检任务分页
  getInspectTaskPage: `${baseUrl}/inspectTask/getPage`,

  // 获取巡检记录分页
  getInspectionRecordPage: `${baseUrl}/inspectRecord/getPage`,

  // 导出巡检记录
  exportInspectionRecord: `${baseUrl}/inspectRecord/export`,

  // 获取巡检报表分页
  getInspectReportPage: `${baseUrl}/inspectReport/getPage`,

  // 导出巡检报表
  exportInspectionReport: `${baseUrl}/inspectReport/export`,

  // 责任人
  getResponsiblePersonList: `${baseUrl2}/person/getResponsiblePersonList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Inspection.js